export default "__VITE_ASSET__CChOaLhM__"